import styled from 'styled-components'

interface IDepartmentSelectSelectStyledProps {}

export const DepartmentSelectSelectStyled = styled.div<IDepartmentSelectSelectStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  min-width: 100%;
`
